import { useConfirmDialog } from './useConfirmDialog'

export function useConfirm(message: string): Promise<boolean> {
  const { open } = useConfirmDialog()
  return open({ message })
}